<template>
  <el-drawer
    :visible.sync="localVisible"
    :size="drawerSize"
    direction="rtl"
    :with-header="true"
    @close="handleClose"
  >
    <template slot="title">
      <span class="drawer-title">商户详情</span>
    </template>
    
    <div v-if="merchantData" class="drawer-content">
      <el-descriptions :column="1" border size="small">
        <el-descriptions-item label="商户名称">
          <span class="detail-value">{{ merchantData.merchantName }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="联系人">
          <span class="detail-value">{{ merchantData.contactPerson }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="联系电话">
          <span class="detail-value">{{ merchantData.contactPhone }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="费控表数量">
          <span class="detail-value">{{ merchantData.meterCount }} 台</span>
        </el-descriptions-item>
        <el-descriptions-item label="预充值总金额">
          <span class="detail-value highlight">¥{{ merchantData.prechargeTotal }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="已充电总金额">
          <span class="detail-value highlight">¥{{ merchantData.chargedTotal }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="未使用总金额">
          <span class="detail-value highlight">¥{{ merchantData.unusedTotal }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="已提总金额">
          <span class="detail-value highlight">¥{{ merchantData.withdrawnTotal }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="待提总金额">
          <span class="detail-value highlight">¥{{ merchantData.pendingTotal }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">
          <span class="detail-value">{{ merchantData.createTime }}</span>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    
    <div v-else class="empty-state">
      <i class="el-icon-info"></i>
      <p>暂无数据</p>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'MerchantInfoDetails',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    merchantData: {
      type: Object,
      default: null
    }
  },
  computed: {
    localVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    drawerSize() {
      // 计算30%的宽度
      const windowWidth = window.innerWidth
      return Math.min(windowWidth * 0.5, 800) + 'px'
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped lang="scss">
.drawer-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.drawer-content {
  padding: 20px;
}

.detail-value {
  font-size: 14px;
  color: #606266;
}

.detail-value.highlight {
  color: #409EFF;
  font-weight: 600;
  font-size: 15px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
  
  i {
    font-size: 48px;
    margin-bottom: 16px;
  }
  
  p {
    font-size: 14px;
    margin: 0;
  }
}

// 响应式适配
@media (max-width: 768px) {
  .drawer-content {
    padding: 12px;
  }
  
  ::v-deep .el-descriptions__label,
  ::v-deep .el-descriptions__content {
    padding: 8px 10px;
  }
}
</style>